import { FunctionalComponent, h } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { OnsiteSearchTextResources } from '../config/onsite-search-configuration';

/**
 * Definition of  parameters that the template needs to work.
 */
interface LoadingTemplateProps {
  textResources: OnsiteSearchTextResources;
  // Specify parameters that are required to be passed down to the template here.
}

const LoadingTemplate: FunctionalComponent<LoadingTemplateProps> = ({ textResources }) => {
  return (
    <loading>
      <csc-loading-animation>
        <csc-loading-animation-dot></csc-loading-animation-dot>
        <csc-loading-animation-dot></csc-loading-animation-dot>
        <csc-loading-animation-dot></csc-loading-animation-dot>
      </csc-loading-animation>
      <p>{textResources.loading.text}</p>
    </loading>
  );
};

export default LoadingTemplate;
